import { Controller } from "@hotwired/stimulus"

import { trackStripeCheckoutOpened } from "@/lib/posthog"

// Connects to data-controller="unlock"
export default class extends Controller {
  static targets = ["form", "dialogTrigger"]
  static values = {
    isLoggedIn: Boolean,
    canPurchase: Boolean,
    isUnlocked: Boolean,
    spaceUrl: String,
    itemUrl: String,
    free: { type: Boolean, default: true },
    autoPurchase: { type: Boolean, default: false },
    offersPurchase: { type: Boolean, default: false },
  }

  declare readonly hasFormTarget: boolean
  declare readonly formTarget: HTMLFormElement
  declare readonly hasDialogTriggerTarget: boolean
  declare readonly dialogTriggerTarget: HTMLButtonElement
  declare isLoggedInValue: boolean
  declare canPurchaseValue: boolean
  declare isUnlockedValue: boolean
  declare spaceUrlValue: string
  declare itemUrlValue: string
  declare freeValue: boolean
  declare autoPurchaseValue: boolean
  declare offersPurchaseValue: boolean

  connect() {
    // Auto-trigger purchase if auto_purchase param is set
    if (
      this.autoPurchaseValue &&
      this.offersPurchaseValue &&
      this.isLoggedInValue &&
      this.canPurchaseValue &&
      !this.isUnlockedValue
    ) {
      this.submitPurchase()
    }
  }

  handleUnlock(event: Event) {
    event.preventDefault()

    if (this.freeValue) {
      this.showDialog()
      return
    }

    if (this.offersPurchaseValue) this.submitPurchase()
  }

  // Public method to show the join dialog - can be called programmatically
  showDialog(event?: Event) {
    if (event) event.preventDefault()

    // Click the button with command="show-modal" to open the dialog declaratively
    if (this.hasDialogTriggerTarget) {
      this.dialogTriggerTarget.click()
    }
  }

  private submitPurchase(): void {
    trackStripeCheckoutOpened("purchase")
    if (this.hasFormTarget) {
      this.formTarget.submit()
    }
  }
}
